import { MailOutlined } from '@ant-design/icons';
import { Alert, Button, Card, Form, Input, Result, Typography } from 'antd';
import { FormInstance } from 'antd/lib/form';
import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import AccountApiService from '../../api/AccountApiService';
import PageTitle from '../../components/shared/PageTitle';
import Routes from '../../config/Routes';
import BaseFormState from '../../redux/bases/BaseFormState';
import * as ResendConfirmEmailHandler from '../../handlerModels/ResendConfirmEmailHandler';

interface ResendConfirmationEmailState extends BaseFormState {
  resendSuccess: boolean;
}

interface ResendConfirmationEmailProps {
}

class ResendConfirmationEmailPage extends React.Component<ResendConfirmationEmailProps & RouteComponentProps<RouteObject>, ResendConfirmationEmailState> {
  private readonly _formRef = React.createRef<FormInstance>();

  constructor(props: ResendConfirmationEmailProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      resendSuccess: false
    };
  }

  handleSubmit = () => {
    this.setState({ loading: true });

    const model = this._formRef ? (this._formRef.current as any).getFieldsValue() : null;

    const request = ResendConfirmEmailHandler.Request.create({
      email: model.email
    })

    AccountApiService.resendConfirmEmail(request).then(
      () => {
        this.setState({ loading: false, resendSuccess: true, error: false });
      },
      (error) => {
        this.setState({ loading: false, error: true, message: error.message, resendSuccess: false });
      }
    );
  }

  render() {
    return this.state.resendSuccess ? this.renderSuccess() : this.renderForm();
  }

  renderForm() {
    return (
      <Card>
        <PageTitle title="Resend Confirmation Email" />
        <Typography.Paragraph>Please enter the email associated with your new account.</Typography.Paragraph>

        {this.renderMessage()}

        <Form ref={this._formRef} layout="vertical" onFinish={this.handleSubmit} requiredMark={false}>
          <Form.Item name="email" label="Email Address" rules={[{ required: true, message: 'Email is required' }]} >
            <Input prefix={<MailOutlined />} disabled={this.state.loading} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" size="large" disabled={this.state.loading} loading={this.state.loading} block={true}>
              Resend Email
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  }

  renderMessage() {
    if (this.state.error) {
      let message = 'An error occurred while trying to resend the confirmation email.';
      if (this.state.message) {
        message = this.state.message;
      }

      return (
        <Alert
          message="Error"
          description={message}
          type="error"
          showIcon={true}
        />);
    }
  }

  renderSuccess() {
    return (
      <Card>
        <Result
          title="Check Your Inbox"
          icon={<MailOutlined />}
          subTitle="An email with a link to confirm your account was sent to the email you provided. Please check your inbox and follow the included steps to confirm your account."
          extra={
            <Link to={Routes.generate(Routes.LOGIN)}>
              <Button type="primary" size="large">
                Go to Login
              </Button>
            </Link>
          } />
      </Card>
    )
  }
}

export default withRouter(ResendConfirmationEmailPage);